import React, { Component } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Navigate } from "react-router-dom";

import Controller from "../Containers/Controller_Cont.js";
import Brochure from "../../Pages/Brochure/Component/Brochure.js";
import Header from "../../Pages/Header/Components/Header.js";
import Navbar from "../../Pages/Nav/Components/Navbar.js";

import Home from "../../Pages/Home/Component/HOME2.jsx";
import Syros from "../../Pages/Cars/Syros/Component/SYROS.jsx";
import SyrosEV from "../../Pages/Cars/SyrosEV/Component/SYROSEV.jsx";
import Sorento from "../../Pages/Cars/Sorento/Component/SORENTO.jsx";
// import Seltos from "../../Pages/Cars/Seltos/Component/SELTOS.jsx";
import NewSeltos from "../../Pages/Cars/NEWSELTOS/NewSeltos.jsx";
import Sonet from "../../Pages/Cars/Sonet/Component/SONET.jsx";
import Carens from "../../Pages/Cars/Carens/Component/CARENS.jsx";
import Ev6 from "../../Pages/Cars/EV6/Component/Ev6.jsx";
import Carnival from "../../Pages/Cars/Carnival/Component/CARNIVAL.jsx";
import Ev9 from "../../Pages/Cars/EV9/Component/Ev9.jsx";
import Clavis from "../../Pages/Cars/Clavis/Components/Clavis.jsx";

import Contact from "../../Pages/contact/Container/contactCon.js";
import Enquiry from "../../Pages/Enquiry/Container/enquiryCon.js";
import Service from "../../Pages/Services/Container/ServiceCon.js";
import Pricing from "../../Pages/Pricing/Containers/pricingCon.js";
import Preowned from "../../Pages/Preownedcars/Container/preownedCon.js";
import Footer from "../../Pages/Footer/Component/Footer.js";
import Clientnav from "../../Client/Containers/NavbarCont.js";
import Advertisement from "../../Client/Containers/advertisementCon.js";
import Oldcar from "../../Client/Containers/oldCarCont.js";
import Admindashboard from "../../Client/Containers/dashboardCon.js";
import EditPage from "../../Client/Containers/addEditCarCon.js";
import View from "../../Client/Containers/ViewpageCon.js";
import Addinginfo from "../../Client/Containers/addOldCarsCon.js";
import Overview from "../../Client/Containers/addOverviewsCon.js";
import Specification from "../../Client/Containers/addSpecificationsCon.js";
import Features from "../../Client/Containers/addFeaturesCon.js";
import Login from "../../Auth/Containers/Login_Cont.js";
import ContactDetails from "../../Client/Containers/ContactDetailsCon.js";
import TestDrive from "../../Client/Containers/testDriveCon.js";
import Services from "../../Client/Containers/serviceCon.js";
import Profile from "../../Pages/Profile/Containers/ProfileCont.js";
import Car1 from "../../Pages/car-details/Container/overviewCon.js";
import VehicleEnq from "../../Client/Containers/vehicleEnqCon.js";
import Enquirys from "../../Client/Containers/enquiryCon.js";
import Quatation from "../../Client/Containers/quatations.js";
import About from "../../Pages/AboutUs/components/aboutus.jsx";
import Headersupportpage from "../../Pages/Support/Component/Support.js";
import CARENSCLAVISEV from "../../Pages/Cars/CARENS CLAVIS EV/Component/CARENSCLAVISEV.jsx";
import SADrawerLayout from "./SADrawerLayout.jsx";
import NotFoundPage from "../../Client/Components/Common/404.jsx";
import Connect from "../../Pages/Connect/Component/connect";
import PrivacyPolicy from "../../Pages/PrivacyPolicy/Components/PrivacyPolicy";
import TermsAndConditions from "../../Pages/TermsAndConditions/Components/TermsAndConditions";

class Routers extends Component {
  render() {
    const { login } = this.props;
    let body;

    if (login.isHome) {
      body = (
        <div>
          <main style={{ flexGrow: 1 }}>
            <Controller />
            <Routes>
              <Route
                path="/"
                element={
                  <>

                    <Header />
                    <Navbar />
                    <Home />
                    <Footer />
                  </>
                }
              />
              <Route
                path="/car-details/:id/:brand"
                element={
                  <>
                    <Header />
                    <Navbar />
                    <Car1 />
                    <Footer />
                  </>
                }
              />
              <Route
                path="/quotations"
                element={
                  <>
                    <Header />
                    <Navbar />
                    <Pricing />
                    <Footer />
                  </>
                }
              />
              <Route
                path="/brochure"
                element={
                  <>
                    <Header />
                    <Navbar />
                    <Brochure />
                    <Footer />
                  </>
                }
              />


              <Route
                path="/newseltos"
                element={
                  <>

                    <Header />
                    <Navbar />
                    <NewSeltos />
                    <Footer />
                  </>
                }
              />
              <Route
                path="/sonet"
                element={
                  <>

                    <Header />
                    <Navbar />
                    <Sonet />
                    <Footer />
                  </>
                }
              />
              <Route
                path="/carens"
                element={
                  <>

                    <Header />
                    <Navbar />
                    <Carens />
                    <Footer />
                  </>
                }
              />




              <Route
                path="/carens-clavis-ev"
                element={
                  <>

                    <Header />
                    <Navbar />
                    <CARENSCLAVISEV />
                    <Footer />
                  </>
                }
              />




              <Route
                path="/ev6"
                element={
                  <>

                    <Header />
                    <Navbar />
                    <Ev6 />
                    <Footer />
                  </>
                }
              />
              <Route
                path="/ev9"
                element={
                  <>

                    <Header />
                    <Navbar />
                    <Ev9 />
                    <Footer />
                  </>
                }
              />
              <Route
                path="/carnival"
                element={
                  <>

                    <Header />
                    <Navbar />
                    <Carnival />
                    <Footer />
                  </>
                }
              />
              <Route
                path="/syros"
                element={
                  <>

                    <Header />
                    <Navbar />
                    <Syros />
                    <Footer />
                  </>
                }
              />
              <Route
                path="/syros-ev"
                element={
                  <>

                    <Header />
                    <Navbar />
                    <SyrosEV />
                    <Footer />
                  </>
                }
              />
              <Route
                path="/sorento"
                element={
                  <>

                    <Header />
                    <Navbar />
                    <Sorento />
                    <Footer />
                  </>
                }
              />
              <Route

                path="/carens-clavis"
                element={
                  <>

                    <Header />
                    <Navbar />
                    <Clavis />
                    <Footer />
                  </>
                }
              />

              <Route
                path="/preowned"
                element={
                  <>

                    <Header />
                    <Navbar />
                    <Preowned />
                    <Footer />
                  </>
                }
              />
              <Route
                path="/contact"
                element={
                  <>

                    <Header />
                    <Navbar />
                    <Contact />
                    <Footer />
                  </>
                }
              />
              <Route
                path="/enquiry"
                element={
                  <>
                    <Header />
                    <Navbar />
                    <Enquiry />
                    <Footer />
                  </>
                }
              />
              <Route
                path="/service"
                element={
                  <>

                    <Header />
                    <Navbar />
                    <Service />
                    <Footer />
                  </>
                }
              />
              <Route
                path="/support"
                element={
                  <>
                    <Header />
                    <Navbar />
                    <Headersupportpage />
                    <Footer />
                  </>
                }
              />
              <Route
                path="/about"
                element={
                  <>

                    <Header />
                    <Navbar />
                    <About />
                    <Footer />
                  </>
                }
              />
              <Route path="/connect" element={<Connect />} />
               <Route
                path="/privacy-policy"
                element={
                  <>
                     <Header />
                    <Navbar />
                    <PrivacyPolicy />
                  </>
                }
              />

              <Route
                path="/terms-and-conditions"
                element={
                  <>
                   <Header />
                    <Navbar />
                    <TermsAndConditions />
                  </>
                }
              />
              {/* <Route path='/pre-owned' element={<><Navbar/><Preowned/><Footer/></>}/> */}
              <Route path="/admin" element={<Login />} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </main>
        </div>
      );
    } else {
      switch (login.type) {
        case "SA":
          body = (
            <Routes>
              <Route path="/admin" element={<Navigate to="/dashboard" replace />} />
              <Route element={<SADrawerLayout />}>
                <Route path="/dashboard" element={<Admindashboard />} />
                <Route path="/advertisement" element={<Advertisement />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/vehicle-enquiry" element={<VehicleEnq />} />
                <Route path="/enquiry" element={<Enquirys />} />
                <Route path="/quatation" element={<Quatation />} />

                <Route path="/contact-details" element={<ContactDetails />} />
                <Route path="/service-request" element={<Services />} />
                <Route path="/oldcar" element={<Oldcar />} />
                <Route path="/book-test-drive" element={<TestDrive />} />
                <Route path="/addinfo" element={<Addinginfo />} />
                <Route path="/overview" element={<Overview />} />
                <Route path="/specification" element={<Specification />} />
                <Route path="/feature" element={<Features />} />
                <Route path="/edit/:id" element={<EditPage />} />
                <Route path="/view/:id" element={<View />} />
                <Route path="/about" element={<><Header /><About /><Footer /></>} />
                <Route path="*" element={<NotFoundPage />} />
              </Route>
            </Routes>
          );
          break;
        default:
          body = (
            <div>
              <main style={{ flexGrow: 1 }}>
                <Controller />
                <Routes>
                  <Route path="*" element={<NotFoundPage />} />
                </Routes>
              </main>
            </div>
          );
          break;
      }
    }

    return <Router>{body}</Router>;
  }
}

export default Routers;
